import { DICTS } from "~/data/i18n";
import { useUiStore } from "~/stores/uiStore";

/**
 * Non-React translation reader for use in stores and other modules
 * that run outside a component render. Reads the current `lang` from
 * `uiStore` snapshot — never subscribes. Falls back to EN then to
 * the raw key, matching the `useT()` hook behavior.
 */
export const getT = (k: string): string => {
  const lang = useUiStore.getState().lang;
  return DICTS[lang][k] ?? DICTS.en[k] ?? k;
};
